import { Card, Typography, List } from 'antd';

const TenantOnboarding = () => {
  const items = [
    { title: 'Azure Active Directory App Registration', detail: 'Client + secret or certificate; redirect URIs configured.' },
    { title: 'App Configuration Entries', detail: 'Per-tenant keys for feature flags, endpoints, index names.' },
    { title: 'Azure Key Vault', detail: 'Store Cognitive Search keys, OpenAI key, storage SAS tokens.' },
    { title: 'Cognitive Search Index', detail: 'Create or clone base schema; trigger initial ingestion + schedule.' },
    { title: 'Storage Account Containers', detail: 'Raw uploads, processed, logs; configure lifecycle policies.' },
    { title: 'Event Grid / Functions (optional)', detail: 'Automate re-index on blob upload.' },
    { title: 'Cosmos DB / Database', detail: 'Persist conversations, JSON configs, tenant metadata.' },
    { title: 'Monitoring & Logging', detail: 'App Insights + Log Analytics workspace integration.' },
  ];
  return (
    <Card title="Tenant Onboarding Checklist" className="!bg-[#1F2937] !border !border-solid !border-[#414756] !text-white" classNames={{ header: '!text-white' }}>
      <Typography.Paragraph className="!text-[#9ca3af]">High-level required Azure artifacts when provisioning a new tenant. Automate via pipeline later.</Typography.Paragraph>
      <List
        dataSource={items}
        renderItem={i => (
          <List.Item>
            <div>
              <Typography.Text className="!text-[#E5C100]">{i.title}</Typography.Text>
              <div className="text-[#9ca3af] text-xs">{i.detail}</div>
            </div>
          </List.Item>
        )}
      />
    </Card>
  );
};
export default TenantOnboarding;
